import { HOURS, fmtTime } from "@/data/content";

// Returns dynamic open/closed status based on Europe/Rome time.
export function useOpenStatus() {
  const now = new Date();
  const parts = new Intl.DateTimeFormat("it-IT", {
    timeZone: "Europe/Rome",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).formatToParts(now);

  const hour = parseInt(parts.find((p) => p.type === "hour").value, 10);
  const minute = parseInt(parts.find((p) => p.type === "minute").value, 10);
  const mins = hour * 60 + minute;

  const romeDayStr = new Intl.DateTimeFormat("en-US", {
    timeZone: "Europe/Rome",
    weekday: "long",
  }).format(now);
  const map = {
    Monday: 0,
    Tuesday: 1,
    Wednesday: 2,
    Thursday: 3,
    Friday: 4,
    Saturday: 5,
    Sunday: 6,
  };
  const idx = map[romeDayStr];
  const today = HOURS[idx];

  const toMin = (t) => {
    const [h, m] = t.split(":").map(Number);
    return h * 60 + m;
  };

  if (!today.slots.length) {
    return { open: false, label: "Chiuso oggi", today };
  }

  // Currently within a slot?
  for (const [o, c] of today.slots) {
    const om = toMin(o);
    const cm = toMin(c);
    if (mins >= om && mins < cm) {
      const closingSoon = cm - mins <= 45;
      return {
        open: true,
        label: closingSoon
          ? `Chiude a breve · ${fmtTime(c)}`
          : `Aperto ora · fino alle ${fmtTime(c)}`,
        today,
      };
    }
  }

  // Next opening later today?
  const upcoming = today.slots
    .map(([o]) => toMin(o))
    .filter((om) => om > mins)
    .sort((a, b) => a - b);

  if (upcoming.length) {
    const nextMin = upcoming[0];
    const nextStr = today.slots.find(([o]) => toMin(o) === nextMin)[0];
    const openingSoon = nextMin - mins <= 45;
    return {
      open: false,
      label: openingSoon
        ? `Apre a breve · ${fmtTime(nextStr)}`
        : `Chiuso · apre alle ${fmtTime(nextStr)}`,
      today,
    };
  }

  return { open: false, label: "Chiuso · riapre domani", today };
}
